"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clear = clear;
exports.clearAll = clearAll;
exports.humanize = humanize;
exports.isFedRAMP = isFedRAMP;
exports.load = load;
exports.publicPath = publicPath;
exports.save = save;
exports.toCapitalCase = toCapitalCase;
/* eslint-disable no-restricted-globals */
function isFedRAMP() {
  // FedRAMP is never valid
  return process.env.REACT_APP_FIPS_ENABLED === 'true';
}
function publicPath() {
  var _path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var path = _path.charAt(0) === '/' ? _path : '/' + _path;
  return "".concat(process.env.PUBLIC_URL).concat(path);
}
function humanize(bytes, si, onlyUnit) {
  var thresh = si ? 1000 : 1024;
  var newBytes = bytes;
  if (Math.abs(newBytes) < thresh) {
    if (onlyUnit) {
      return 'B';
    }
    return newBytes + ' B';
  }
  var units = ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  // technically 1024 should be using the notation below, but in order to stay
  // on par with AWS we're going to use 1024 but display KB/GB/TB/ etc.
  // : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  var u = -1;
  do {
    newBytes /= thresh;
    ++u;
  } while (Math.abs(newBytes) >= thresh && u < units.length - 1);
  if (onlyUnit) {
    return units[u];
  }
  return newBytes.toFixed(3) + ' ' + units[u];
}
function save(path, value) {
  try {
    var valueString = JSON.stringify(value);
    localStorage.setItem(path, valueString);
    return true;
  } catch (error) {
    return false;
  }
}
function load(path, defaultValue) {
  try {
    var valueString = localStorage.getItem(path);
    if (valueString === null) {
      return defaultValue;
    }
    return JSON.parse(valueString);
  } catch (error) {
    return defaultValue;
  }
}
function clear(path) {
  localStorage.removeItem(path);
}
function clearAll() {
  localStorage.clear();
}
function toCapitalCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}